import React from "react";
import { Form, Row, Col } from "antd";

import { useForm } from "react-hook-form";
import { TextAreaField } from "../../../../atoms/FormElement";
import { ButtonGroup } from "../../../../molecules/Button/ButtonGroup";

type RejectApprovalFormValues = {
  reason: string;
};

type RejectApprovalProps = {
  setRejectApproval: React.Dispatch<React.SetStateAction<boolean>>;
  handleApprove: (reason: string) => void;
  loading: boolean;
};

export const RejectApproval = (props: RejectApprovalProps) => {
  const { setRejectApproval, handleApprove, loading } = props;

  const {
    control,
    formState: { errors },
    // reset,
    handleSubmit,
  } = useForm<RejectApprovalFormValues>();

  const handleReject = (data: RejectApprovalFormValues) => {
    // reset();
    handleApprove(data.reason);
  };
  return (
    <Form layout="vertical" onFinish={handleSubmit(handleReject)} style={{ padding: "20px" }}>
      <Row gutter={24}>
        <Col span={24}>
          <TextAreaField
            label="Enter Reason"
            fieldname="reason"
            isRequired={true}
            disable={loading}
            rules={{ required: "Reason required" }}
            validate={errors.reason && "error"}
            validMessage={errors.reason && errors.reason.message}
            iProps={{
              placeholder: "Some reason....",
            }}
            initValue=""
            control={control}
          />
        </Col>
      </Row>

      <ButtonGroup
        align="space-between"
        primaryButton={{ label: "Submit", loading, htmlType: "submit" }}
        secondaryButton={{ label: "Back", disabled: loading, onClick: () => setRejectApproval(false) }}
      />
    </Form>
  );
};
